import { createTheme, alpha, Theme } from '@mui/material/styles';
import { theme as appTheme } from './index';

/** Persistencia del toggle beta solo en catálogo de productos */
export const PRODUCT_CATALOG_DARK_PREVIEW_KEY = 'product-catalog-dark-preview';

/** Persistencia del toggle beta en registro de inventario */
export const INVENTORY_REGISTER_DARK_PREVIEW_KEY = 'inventory-register-dark-preview';

/** Persistencia del toggle beta en gestión en almacén */
export const WAREHOUSE_MANAGEMENT_DARK_PREVIEW_KEY = 'warehouse-management-dark-preview';

/**
 * Tema oscuro global (slate alineado con el dashboard: #0f172a / #1e293b).
 * Usado por App → ThemedApplication junto con ColorModeContext.
 */
export const catalogDarkTheme = createTheme(appTheme, {
  palette: {
    mode: 'dark',
    primary: appTheme.palette.primary,
    secondary: appTheme.palette.secondary,
    success: appTheme.palette.success,
    warning: appTheme.palette.warning,
    error: appTheme.palette.error,
    info: appTheme.palette.info,
    background: {
      default: '#0f172a',
      paper: '#1e293b',
    },
    text: {
      primary: '#f9fafb',
      secondary: '#94a3b8',
      disabled: '#64748b',
    },
    divider: '#334155',
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    /** Diálogos: papel slate (objeto para que el merge conserve radius/sombra del tema base). */
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e293b',
          backgroundImage: 'none',
        },
      },
    },
    /** Inputs outlined (TextField, Select): superficie slate, sin bloque blanco. */
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) =>
          theme.palette.mode === 'dark'
            ? {
                backgroundColor: alpha(theme.palette.common.white, 0.06),
                '&:hover': {
                  backgroundColor: alpha(theme.palette.common.white, 0.09),
                },
                '&.Mui-focused': {
                  backgroundColor: alpha(theme.palette.common.white, 0.09),
                },
              }
            : {},
        notchedOutline: ({ theme }: { theme: Theme }) =>
          theme.palette.mode === 'dark'
            ? {
                borderColor: theme.palette.divider,
              }
            : {},
      },
    },
  },
});
